import { action, makeObservable, observable } from 'mobx';
import { defaultMinOdd, minOddConstant } from '../enums/gameConstants';

class GameStore {
  gameTypeId = null;

  allGameTypes = [];

  isBetsClosedByGameType = {};

  roundId = {};

  minOdd = minOddConstant;

  defaultMinOdd = defaultMinOdd;

  numPadData = {
    isOpenNumpad: false,
    sectionName: null,
    currentInputValue: null,
  };

  underMaintenance = [];

  partnerWageringOdd = null;

  activeGameType = null;

  isPongReceived = false;

  constructor() {
    makeObservable(this, {
      activeGameType: observable,
      partnerWageringOdd: observable,
      allGameTypes: observable,
      isPongReceived: observable,
      defaultMinOdd: observable,
      gameTypeId: observable,
      numPadData: observable,
      isBetsClosedByGameType: observable.deep,
      underMaintenance: observable.deep,
      roundId: observable.deep,
      setIsBetsClosed: action.bound,
      setInitialBetsClosed: action.bound,
      setNumPadData: action.bound,
      setMinOdd: action.bound,
      setDefaultMinOdd: action.bound,
      setPartnerWageringOdd: action.bound,
      setAllGameTypes: action.bound,
      setActiveGameType: action.bound,
      setUnderMaintenance: action.bound,
      setIsPongReceived: action.bound,
    });
  }

  setIsPongReceived(isPongReceived) {
    this.isPongReceived = isPongReceived;
  }

  setUnderMaintenance(gameTypeId) {
    this.underMaintenance.push(gameTypeId);
  }

  setMinOdd(value) {
    this.minOdd = value;
  }

  setDefaultMinOdd(value) {
    this.defaultMinOdd = value;
  }

  setPartnerWageringOdd(value) {
    this.partnerWageringOdd = value;
  }

  setRoundId(roundId, gameType) {
    this.roundId[gameType] = roundId;
  }

  setActiveGameType(gameType) {
    this.activeGameType = gameType;
  }

  setAllGameTypes(gameTypeList) {
    this.allGameTypes = gameTypeList;
  }

  setIsBetsClosed(bool, gameTypeId) {
    if (gameTypeId) {
      this.isBetsClosedByGameType[gameTypeId] = bool;
    }
  }

  setInitialBetsClosed(data) {
    this.isBetsClosedByGameType = data;
  }

  setNumPadData(data) {
    this.numPadData = data;
  }
}

export const gameStore = new GameStore();
